module.exports = __webpack_public_path__ + "media/images/poster_ukraine-256a0283.png";